// remove empty options from form data by a list of properties
export const removeEmptyOptions = (form: Record<string, any>, properties: string[] = []) => {
    const filteredForm = { ...form };

    for (const property of properties) {
        if (filteredForm?.[property]?.length) {
            filteredForm[property] = filteredForm[property].filter((optionValue: string) => optionValue !== "");
        }
    }
    return filteredForm;
};
